module.exports = __webpack_public_path__ + "static/media/Artboard2.e76a5abb.png";